const TOGGLE_COMPACT_MODE = 'timeline/TOGGLE_COMPACT_MODE';

const SET_DIRTY = 'timeline/SET_DIRTY';

export default { TOGGLE_COMPACT_MODE, SET_DIRTY };
